import angular from 'angular';

import { CommonModule } from './common/common.module';
import { MenuModule } from './menu/menu.module';
import { ModifiersModule } from './modifiers/modifiers.module';
import { SummaryModule } from './summary/summary.module';

export const OrderModule = angular
    .module('oo.order', [
        CommonModule,
        MenuModule,
        ModifiersModule,
        SummaryModule
    ])
    .name;
